const configLayout = {
  APPBAR_MOBILE: 64,
  APPBAR_DESKTOP: 80,
  DRAWER_WIDTH: 290,
  DRAWER_WIDTH_CLOSE: 75
};

export default configLayout;
